<div class="d-flex justify-content-center align-items-center p-5">
  <div class="bg-white shadow rounded p-4 w-100">
    <div class="row">
      <h3>{{ translationService.getTranslation('Exam Violations') }}</h3>
      <hr>
      <div class="row g-4">
        <div class="col-3" *ngFor="let widget of widgets" (click)="openModal(widget)">
          <div class="card shadow-sm border-0 btn bg-light">
            <div class="card-body text-center">
              <h5 class="card-title text-muted">{{ translationService.getTranslation(widget.title) }}</h5>
              <h1 class="display-2" [ngClass]="widget.colorClass">{{ widget.count }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <h3>{{ translationService.getTranslation('Candidates Currently Testing') }}</h3>
      <hr>
      <div class="table-responsive">
        <table class="table table-bordered table-striped table-hover">
          <thead class="table-success">
            <tr>
              <th>{{ translationService.getTranslation('ID') }}</th>
              <th>{{ translationService.getTranslation('Exam Attendance Number') }}</th>
              <th>{{ translationService.getTranslation('Candidate Name') }}</th>
              <th>{{ translationService.getTranslation('Phone Number') }}</th>
              <th>{{ translationService.getTranslation('Gender') }}</th>
              <th>{{ translationService.getTranslation('Book Type') }}</th>
              <th>{{ translationService.getTranslation('Course Name') }}</th>
              <th>{{ translationService.getTranslation('Language') }}</th>
              <th>{{ translationService.getTranslation('Start Exam') }}</th>
              <th>{{ translationService.getTranslation('Flag') }}</th>
            </tr>                
          </thead>
          <tbody>
            <tr *ngFor="let candidate of candidatesCurrentlyTesting">
              <td>{{ candidate.IDNumber }}</td>
              <td>{{ candidate.ExamAttendanceNo }}</td>
              <td>{{ candidate.TraineeName }}</td>
              <td>{{ candidate.PhoneNumber }}</td>
              <td>{{ candidate.Gender }}</td>
              <td>{{ candidate.BookingType }}</td>
              <td>{{ candidate.CourseName }}</td>
              <td>{{ candidate.LanguageName }}</td>
              <td>{{ candidate.StartExamDate | date:'HH:mm' }}</td>
              <td>
                <i class="bi bi-flag-fill text-danger me-2" (click)="openModal(candidate)" style="cursor: pointer;"></i>
              </td>
            </tr>                               
          </tbody>
        </table>
      </div>
    </div> 
  </div> 

  <div *ngIf="reportedModal && reportedCandidates.length > 0" class="modal fade show" tabindex="-1" role="dialog" style="display: block;">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ translationService.getTranslation('Reports') }}</h5>
          <button type="button" class="btn-close mx-3" (click)="closeModal()" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div class="table-responsive">
            <table class="table table-bordered table-striped table-hover">
              <thead class="table-success">
                <tr>
                  <th>{{ translationService.getTranslation('ID') }}</th>
                  <th>{{ translationService.getTranslation('Exam Attendance Number') }}</th>
                  <th>{{ translationService.getTranslation('Candidate Name') }}</th>
                  <th>{{ translationService.getTranslation('Phone Number') }}</th>
                  <th>{{ translationService.getTranslation('Gender') }}</th>
                  <th>{{ translationService.getTranslation('Book Type') }}</th>
                  <th>{{ translationService.getTranslation('Course Name') }}</th>
                  <th>{{ translationService.getTranslation('Language') }}</th>
                  <th>{{ translationService.getTranslation('Start Exam') }}</th>
                  <th>{{ translationService.getTranslation('Flag') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let candidate of reportedCandidates">
                  <td>{{ candidate.IDNumber }}</td>
                  <td>{{ candidate.ExamAttendanceNo }}</td>
                  <td>{{ candidate.TraineeName }}</td>
                  <td>{{ candidate.PhoneNumber }}</td>
                  <td>{{ candidate.Gender }}</td>
                  <td>{{ candidate.BookingType }}</td>
                  <td>{{ candidate.CourseName }}</td>
                  <td>{{ candidate.LanguageName }}</td>
                  <td>{{ candidate.StartExamDate | date:'HH:mm' }}</td>
                  <td>
                    <i class="bi bi-eye text-primary me-2" (click)="viewReport(candidate)" style="cursor: pointer;"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="candidateModal" class="modal fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display: block;">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ translationService.getTranslation('Submit Report') }}</h5>
          <button type="button" class="btn-close mx-3" (click)="closeModal()" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-4 mb-3" *ngFor="let field of [
                { label: translationService.getTranslation('ID'), value: selectedCandidate?.IDNumber },
                { label: translationService.getTranslation('Exam Attendance Number'), value: selectedCandidate?.ExamAttendanceNo },
                { label: translationService.getTranslation('Candidate Name'), value: selectedCandidate?.TraineeName },
                { label: translationService.getTranslation('Phone Number'), value: selectedCandidate?.PhoneNumber },
                { label: translationService.getTranslation('Gender'), value: selectedCandidate?.Gender },
                { label: translationService.getTranslation('Book Type'), value: selectedCandidate?.BookingType },
                { label: translationService.getTranslation('Course Name'), value: selectedCandidate?.CourseName },
                { label: translationService.getTranslation('Language'), value: selectedCandidate?.LanguageName },
                { label: translationService.getTranslation('Start Exam'), value: selectedCandidate?.StartExamDate | date: 'yyyy-MM-dd - h:mm a' },
                { label: translationService.getTranslation('Exam Result'), value: selectedCandidate?.ExamResult },
                { label: translationService.getTranslation('Branch City'), value: selectedCandidate?.CityName || 1 },
                { label: translationService.getTranslation('Created Date'), value: currentDate | date: 'yyyy-MM-dd - h:mm a' },
                { label: translationService.getTranslation('Exam Supervisor Name'), value: currentUser },
                { label: translationService.getTranslation('Exam Supervisor Email'), value: currentEmail }
              ]">
                <label class="form-label">{{ field.label }}</label>
                <input type="text" class="form-control" [value]="field.value" disabled>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">{{ translationService.getTranslation('Exam Invigilator Name') }}</label>
                <input type="text" class="form-control" [(ngModel)]="ExamInvigilatorName">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">{{ translationService.getTranslation('Incident Information') }}</label>
                <textarea class="form-control" rows="4" [(ngModel)]="IncidentInformation"></textarea>
              </div>
              <div class="col-md-12 mb-3">
                <label class="form-label">{{ translationService.getTranslation('Action Taken') }}</label>
                <textarea class="form-control" rows="3" [(ngModel)]="ActionTaken"></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-danger" (click)="closeModal()">
            <i class="bi bi-x-circle"></i> {{ translationService.getTranslation('Close') }}
          </button>
          <button type="button" class="btn btn-success" (click)="createReport()" [disabled]="!this.ExamInvigilatorName || !this.IncidentInformation || !this.ActionTaken">
            <i class="bi bi-flag-fill"></i> {{ translationService.getTranslation('Create Report') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
